import React from 'react';

import {LoadView,LoadView2} from './LoadView';
import UnloadView from './UnloadView';
import { useFeatureToggleItems } from 'components/FeatureToggle';
import featureToggles from 'config/featureToggles';

const InProgressView = ({ isLoad, ...rest }) => {
  const loadViewFeatureToggle = useFeatureToggleItems(featureToggles.BTC_MONITOR_LOAD_VIEW);

  const SwitchLoadView=()=>{
    if(loadViewFeatureToggle[0]?.variant==='v2')
         return <LoadView2 {...rest}/>
    else return <LoadView {...rest}/>  
  }
  
  return isLoad ? <SwitchLoadView /> : <UnloadView {...rest} />
};

export default InProgressView;